import { init } from 'src/services/network';

/**
 * Initialize network service.
 *
 * @param {Object} params
 * @param {VueRouter} params.router
 * @param {import('node_modules/vuex/types/index').Store} params.store
 */
export default ({ router, store }) => {
  init({ router, store });
};
